import React, { useEffect, useRef, useState } from 'react'
import { Loader } from 'rsuite'
import { LoaderOverlay } from './styles/UniversalLoader.styles'

interface UniversalLoaderProps {
  show: boolean
  content?: string
  style?: React.CSSProperties
  useParentSize?: boolean
}

const UniversalLoader: React.FC<UniversalLoaderProps> = ({
  show,
  content = 'Loading...',
  style,
  useParentSize = true,
}) => {
  const [isVisible, setIsVisible] = useState<boolean>(false)
  const overlayRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (show && overlayRef.current) {
      const parent = overlayRef.current.parentElement

      if (parent && useParentSize) {
        const parentStyles = window.getComputedStyle(parent)

        if (parentStyles.position === 'static') {
          parent.style.position = 'relative'
          parent.style.zIndex = '0'
        }
      }

      // Use RAF to ensure smooth transition
      requestAnimationFrame(() => {
        setIsVisible(true)
      })
    } else {
      setIsVisible(false)
    }
  }, [show, useParentSize])

  if (!show) return null

  return (
    <LoaderOverlay
      ref={overlayRef}
      className={isVisible ? 'visible' : ''}
      style={style}
      useParentSize={useParentSize}
    >
      <Loader content={content} vertical size="md" />
    </LoaderOverlay>
  )
}

export default UniversalLoader
